export const statusDict = {
  UNDERREVIEW: "Under Review",
  APPROVE: "Approved",
  DISAPPROVE: "Disapproved",
  PENDING: "Pending",
  PUBLIC: "Public",
  DESTROY: "Destroyed",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  READY: "Ready",
  COMPLETE: "Complete",
  ARCHIVE: "Archive",
  CONFIRMED: "Confirmed",
  RETURNED: "Returned",
  CANCELED: "Canceled",
  DELIVERED: "Delivered",
  DRAFT: "Draft",
  CONFIRM: "Confirmed",
  APPROVED: "Approved",
  REGISTERED: "Register",
  REGISTER_FAILED: "Register failed",
  SAVED: "Saved",
  PROCESSING: "Processing",
  BANK_REJECTED: "Bank rejected",
};

export const ACP_API_ENDPOINT =
  process.env.REACT_APP_ENV !== "production"
    ? "https://api-acp.tala.xyz"
    : "https://api-acp.tiki.vn";

export const SC_API_ENDPOINT =
  process.env.REACT_APP_ENV !== "production"
    ? "https://api-sellercenter.tala.xyz"
    : "https://api-sellercenter.tiki.vn";
